import { TROLE_BASED_ACTION_CONF } from '@monorepo/types';

type TMachineMaintenanceComponentType =
  | 'MACHINE_ACTION_MODAL'
  | 'LINE_ACTIONS'
  | 'LINE_DETAILS'
  | 'LINE_OVERVIEW'
  | 'SHIFT_MANAGEMENT'
  | 'MACHINE_LISTING'
  | 'CONFIG_SETUP'
  | 'LOCATION_LISTING'
  | 'BREAKDOWN_REASONS'
  | 'MACHINE_SERVICE'
  | 'SPAREPART_REQUEST_LISTING'
  | 'SPAREPART_LISTING'
  | 'NEEDLE_REQUEST_LISTING';

export const ROLE_BASED_ACTION_HELPER = {
  getRoleBasedActionConf(component: TMachineMaintenanceComponentType): TROLE_BASED_ACTION_CONF {
    switch (component) {
      case 'MACHINE_ACTION_MODAL': {
        return {
          CREATE_MACHINE_ISSUE_TICKET: {
            id: 'CREATE_MACHINE_ISSUE_TICKET',
            featureCode: 'TICKET_CREATE',
            show: true,
          },
          CREATE_MAINTENANCE_TICKET: {
            id: 'CREATE_MAINTENANCE_TICKET',
            featureCode: 'MAINTENANCE_TICKET_CREATE',
            show: true,
          },
          VIEW_MACHINE_HISTORY: {
            id: 'VIEW_MACHINE_HISTORY',
            featureCode: 'MACHINE_LOG_VIEW',
            show: true,
          },
          NPT_EDIT: {
            id: 'NPT_EDIT',
            featureCode: 'NPT_EDIT',
            show: true,
          },
          ASSIGN_ATTACHMENT: {
            id: 'ASSIGN_ATTACHMENT',
            featureCode: 'ASSIGN_ATTACHMENT',
            show: true,
          },
        };
      }
      case 'LINE_ACTIONS': {
        return {
          ASSIGN_MACHINE: {
            id: 'ASSIGN_MACHINE',
            featureCode: 'WORKSTATION_MACHINE_ADD',
            show: true,
          },
          REPLACE_MACHINE: {
            id: 'REPLACE_MACHINE',
            featureCode: 'WORKSTATION_MACHINE_REPLACE',
            show: true,
          },
          REMOVE_MACHINE: {
            id: 'REMOVE_MACHINE',
            featureCode: 'WORKSTATION_MACHINE_REMOVE',
            show: true,
          },
          DELETE_MACHINE: {
            id: 'DELETE_MACHINE',
            featureCode: 'WORKSTATION_DELETE',
            show: true,
          },
        };
      }
      case 'LINE_DETAILS': {
        return {
          VIEW_MACHINE_DETAILS: {
            id: 'VIEW_MACHINE_DETAILS',
            featureCode: 'MACHINE_VIEW',
            show: true,
          },
          ADD_WORKSTATION: {
            id: 'ADD_WORKSTATION',
            featureCode: 'WORKSTATION_ADD',
            show: true,
          },
        };
      }
      case 'LINE_OVERVIEW': {
        return {
          RESET_LINE: {
            id: 'RESET_LINE',
            featureCode: 'LINE_RESET',
            show: true,
          },
          LINE_SETUP: {
            id: 'LINE_SETUP',
            featureCode: 'LINE_VIEW',
            show: true,
          },
          WORKSTATION_LIST_VIEW: {
            id: 'WORKSTATION_LIST_VIEW',
            featureCode: 'WORKSTATION_LIST_VIEW',
            show: true,
          },
        };
      }
      case 'SHIFT_MANAGEMENT': {
        return {
          ADD_OVERTIME: {
            id: 'ADD_OVERTIME',
            featureCode: 'SHIFT_EDIT',
            show: true,
          },
          ADD_STANDARD_TIME: {
            id: 'ADD_STANDARD_TIME',
            featureCode: 'SHIFT_EDIT',
            show: true,
          },
        };
      }
      case 'MACHINE_LISTING': {
        return {
          ASSIGN_LOCATIONS: {
            id: 'ASSIGN_LOCATIONS',
            featureCode: 'LOCATION_ASSIGN_EMPLOYEE_BULK',
            show: true,
          },
          UPDATE_STATUS: {
            id: 'UPDATE_STATUS',
            featureCode: 'UPDATE_MACHINE_STATUS',
            show: true,
          },
          UPDATE_QR_PRINTED_STATUS: {
            id: 'UPDATE_QR_PRINTED_STATUS',
            featureCode: 'MACHINE_VIEW',
            show: true,
          },
          DELETE_ROW: {
            id: 'DELETE_ROW',
            featureCode: 'MACHINE_EDIT',
            show: true,
          },
          ASSET_MOVEMENT: {
            id: 'ASSET_MOVEMENT',
            featureCode: 'MACHINE_TRANSFER_SIBLING_FACTORY',
            show: true,
          },
          RETURN_TO_VENDOR: {
            id: 'RETURN_TO_VENDOR',
            featureCode: 'MACHINE_RETURN_TO_VENDOR',
            show: true,
          },
          MOVE_BACK_TO_FACTORY: {
            id: 'MOVE_BACK_TO_FACTORY',
            featureCode: 'MACHINE_RETURN_TO_VENDOR',
            show: true,
          },
        };
      }
      case 'LOCATION_LISTING': {
        return {
          ASSIGN_EMPLOYEES: {
            id: 'ASSIGN_EMPLOYEES',
            featureCode: 'EMPLOYEE_VIEW',
            show: true,
          },
          DELETE_ROW: {
            id: 'DELETE_ROW',
            featureCode: 'LOCATION_CREATE_BULK',
            show: true,
          },
          MAP_LOCAL_NEEDLE_STORES: {
            id: 'MAP_LOCAL_NEEDLE_STORES',
            featureCode: 'MAP_LOCAL_NEEDLE_STORE',
            show: true,
          },
        };
      }
      case 'BREAKDOWN_REASONS': {
        return {
          DELETE_ROW: {
            id: 'DELETE_ROW',
            featureCode: 'BREAKDOWN_REASON_EDIT',
            show: true,
          },
        };
      }
      case 'MACHINE_SERVICE': {
        return {
          ADD_CHECKLIST: {
            id: 'ADD_CHECKLIST',
            featureCode: 'MAINTENANCE_SCHEDULE_EDIT',
            show: true,
          },
        };
      }
      case 'SPAREPART_REQUEST_LISTING': {
        return {
          REJECT: {
            id: 'REJECT',
            featureCode: 'SPARE_PART_REQUEST_EDIT',
            show: true,
          },
          APPROVE: {
            id: 'APPROVE',
            featureCode: 'SPARE_PART_REQUEST_EDIT',
            show: true,
          },
        };
      }
      case 'NEEDLE_REQUEST_LISTING': {
        return {
          REJECT: {
            id: 'REJECT',
            featureCode: 'NEEDLE_REQUEST_EDIT',
            show: true,
          },
          APPROVE: {
            id: 'APPROVE',
            featureCode: 'NEEDLE_REQUEST_EDIT',
            show: true,
          },
        };
      }
      case 'CONFIG_SETUP': {
        return {
          HOLIDAY_EDIT: {
            id: 'HOLIDAY_EDIT',
            featureCode: 'HOLIDAY_EDIT',
            show: true,
          },
        };
      }
      case 'SPAREPART_LISTING': {
        return {
          UPDATE_SPAREPART_THRESHOLD: {
            id: 'UPDATE_SPAREPART_THRESHOLD',
            featureCode: 'SPARE_PART_EDIT',
            show: true,
          },
          UPDATE_SPAREPART_CRITICAL: {
            id: 'UPDATE_SPAREPART_CRITICAL',
            featureCode: 'SPARE_PART_EDIT',
            show: true,
          },
          DELETE_SPAREPART: {
            id: 'DELETE_SPAREPART',
            featureCode: 'SPARE_PART_DELETE',
            show: true,
          },
        };
      }
      default:
        return {};
    }
  },
};

export type TSparePartBulkActions = 'UPDATE_THRESHOLD' | 'UPDATE_CRITICAL' | 'DELETE_ROW';
